<div class="wallet-container">

  <div class="back-and-payment-method">
    <div class="selected-payment-method flex justify-center sm:justify-center items-center round-border-normal mt-4 sm:mr-0 sm:mt-8">
      <span class="wpx-200 hpx-125 sm:wpx-250 sm:hpx-150 background-cover rounded-md bg-cover flex justify-center items-center">
        <img class="w-full" [src]="paymentMethodImg">
      </span>
<!--       <div class="mt-2 sm:ml-2 absolute left-0">
        <button
          (click)="goBack()"
          mat-icon-button
          class="sm:text-sm"
          >
            <mat-icon class="sm:mr-2 sm:text-5xl">keyboard_arrow_left</mat-icon>
            BACK
        </button>
      </div>  -->
    </div>
  </div>

  <div class="flex flex-wrap">
    <div *ngIf="loading" class="bg-gray-300 container flex justify-center items-center ml-12 mr-12 mb-16 mt-16" style="border-radius: 12px;">
      <mat-spinner
        class="loading-spinner mb-4 mt-4"
        [color]="color"
        [diameter]="diameter"
      >
      </mat-spinner>
    </div>
    <router-outlet></router-outlet>
  </div>

  <p class="text-sm flex justify-center text-gray-800 mt-2 sm:mt-4 mb-12">Time Remaining: {{ timer }}</p>
  <div class="bottom-container w-full flex flex-row items-end pl-0 pr-0 sm:pl-2 sm:pr-2 pb-0 justify-between absolute bottom-0 mat-typography">
    <p class="text-md sm:text-lg ml-2 text-gray-800 mb-2">This is a secure transaction</p>
    <img *ngIf="!hidePgLogo" class="sm:h-14 h-12 mr-2 mb-0 sm:mr-2 sm:mb-1" src="../../assets/icons/Icons/adumoonline_RGB.png">
  </div>

</div>
